import React, { Component } from 'react';
import classNames from 'classnames';
import RatingItem from './RatingItem';

export type TRatingProps = {
  className?: string;
  star?: number;
};

const MAX_RATING = 5;
export class Rating extends Component<TRatingProps> {
  static defaultProps = {
    star: 0,
  };

  render(): JSX.Element {
    const { className, star } = this.props;

    const cx = classNames({
      rating: true,
      [className]: !!className,
    });

    const width = star === 0 ? 0 : `${(star / MAX_RATING) * 100}%`;

    return (
      <div className={cx} style={{ position: 'relative' }}>
        <div className="rating__body">
          <RatingItem />
          <RatingItem />
          <RatingItem />
          <RatingItem />
          <RatingItem />
        </div>

        <div
          className="rating__body"
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width,
            overflow: 'hidden',
          }}
        >
          <RatingItem isActive />
          <RatingItem isActive />
          <RatingItem isActive />
          <RatingItem isActive />
          <RatingItem isActive />
        </div>
      </div>
    );
  }
}

export default Rating;
